import { IAppState } from '../../redux';
import { selectOfferCategory } from './selectOfferCategory';

export function selectIsDailyRentOffer(state: IAppState): boolean {
  const category = selectOfferCategory(state);
  const isDaily = !!category?.includes('daily');
  const isRent = !!category?.includes('Rent');

  return isDaily && isRent;
}
